module.exports = __webpack_public_path__ + "static/images/dialog-fu.25f3513.png";